import { DocShape } from ".";

export enum MessageSenders {
  Borrower = "borrower",
  Operator = "operator",
  System = "system",
}

export interface MessageShape {
  id?: number;
  sender_id?: number;
  sender_type: MessageSenders;
  message: string;
  created_at: string;
  sender_name: string;
  sender_email: string;
  documents: DocShape[];
  read_by_borrower: boolean;
  read_by_operator: boolean;
  read: boolean;
  thread_id?: string;
}
